import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { useRecordContext } from 'react-admin';

export interface MultipleIpCountriesParams {
  lookbackPeriod: { amount: number; unit: string };
  includeAnonymousIps: boolean;
}

const MultipleIpCountries = () => {
  const record = useRecordContext();

  if (!record) return null;

  const { lookbackPeriod, includeAnonymousIps } = record
    .ruleParameters as MultipleIpCountriesParams;

  return (
    <>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Lookback period
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>{`${lookbackPeriod.amount} ${lookbackPeriod.unit}`}</Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Include anonymous IPs
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>{includeAnonymousIps ? 'Yes' : 'No'}</Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default MultipleIpCountries;
